module.exports = __webpack_public_path__ + "img/coal_turkish2.8f066e81.png";